<div class="ppsr-status-chip-component {{toClass()}}">
  {{status}}
</div>